import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getBrandList = createAsyncThunk(
  'general/getBrandList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await authGet('/general/list/brand');
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
  {
    condition: (_, { getState }) => !getState().getBrandList.loading
  }
);

export default getBrandList;
